const transformNavigationList = ({ results = [] }) =>
  results.map(({ id, destination }) => ({
    id,
    optionLabel: destination,
  }));

export default transformNavigationList;
